import { render, staticRenderFns } from "./TituloPagina.vue?vue&type=template&id=fb869b60"
import script from "./TituloPagina.vue?vue&type=script&lang=js"
export * from "./TituloPagina.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports